import * as React from 'react'

import { Helmet } from 'react-helmet-async'
import { NotFoundLayout } from '../../layouts'

const NotFoundPage = (): React.ReactElement => (
  <>
    <Helmet>
      <title>404 Page Not Found</title>
      <meta name="description" content="Page not found" />
    </Helmet>
    <NotFoundLayout />
  </>
)

export default NotFoundPage
